interface VersionedEntry<T> {
  version: number
  data: T
}

export function readVersioned<T>(key: string, version: number, defaultValue: T): T {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return defaultValue
    const parsed = JSON.parse(raw) as VersionedEntry<T>
    if (parsed && typeof parsed === "object" && parsed.version === version) {
      return parsed.data
    }
    return defaultValue
  } catch {
    return defaultValue
  }
}

export function writeVersioned<T>(key: string, version: number, data: T): void {
  localStorage.setItem(key, JSON.stringify({ version, data }))
}

export function removeVersioned(key: string): void {
  localStorage.removeItem(key)
}
